export function supportEmailHref(user) {
  const subject = "TrailPulse help request";
  const body = [
    "Hi TrailPulse team,", "", "I need help with:", "", "",
    "---", `Name: ${user?.full_name || "Not available"}`,
    `Account: ${user?.email || "Not available"}`,
    `Page: ${window.location.href}`,
  ].join("\n");
  const params = new URLSearchParams({
    to: "support@trailpulse.app,hello@trailpulse.in",
    su: subject,
    body,
    tf: "cm",
  });
  return `https://mail.google.com/mail/?${params.toString()}`;
}

export function openSupportEmail(event, user) {
  // Preserve standard link behaviour for modified clicks.
  if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
  event.preventDefault();
  const width = Math.min(720, window.screen.availWidth);
  const height = Math.min(680, window.screen.availHeight);
  const left = Math.max(0, (window.screenX || 0) + (window.outerWidth - width) / 2);
  const top = Math.max(0, (window.screenY || 0) + (window.outerHeight - height) / 2);
  window.open(supportEmailHref(user), "_blank",
    `popup=yes,width=${width},height=${height},left=${Math.round(left)},top=${Math.round(top)},resizable=yes,scrollbars=yes,noopener,noreferrer`);
}
